var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppearance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00004 13.5H18V2.5H2.00004V13.5ZM11 15.5V17.5H15V19.5H5.00004V17.5H9.00004V15.5H0.992041C0.860727 15.4992 0.730858 15.4725 0.609879 15.4215C0.488899 15.3704 0.379188 15.2959 0.287032 15.2024C0.194877 15.1088 0.122089 14.998 0.0728414 14.8763C0.0235937 14.7546 -0.00114581 14.6243 4.07459e-05 14.493V1.507C4.07459e-05 0.951 0.455041 0.5 0.992041 0.5H19.008C19.556 0.5 20 0.949 20 1.507V14.493C20 15.049 19.545 15.5 19.008 15.5H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppearance);
export default __webpack_public_path__ + "static/media/appearance.4c601e619369bd2b65db72b7d90a0099.svg";
export { ForwardRef as ReactComponent };